import "./header.css";
import React, { useState } from "react";
import logo from "../../assets/images/nocops-logo.png";
import { Link, useLocation } from "react-router-dom";
import { IoMenu, IoClose } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";

const navItems = [
  { to: "/vehicleRegistration", label: "Vehicle Registration" },
  { to: "/UpdateUser", label: "Vehicle Update" },
  { to: "/VehicleRegistrationprevious", label: "Vehicle User Details" },
  { to: "/attendenceLog", label: "Attendance Log" },
  { to: "/TimeEndorsement", label: "Time Endorsement" },
];

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();

  const handleMenuClick = () => {
    setShowMenu(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    <nav className="navbar">
      <div className="navbarBrand">
        <img src={logo} alt="NOCOPS" className="logo" />
      </div>

      <div className="desktopMenu">
        {navItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={
              "desktopMenuItemList" +
              (location.pathname.toLowerCase() === item.to.toLowerCase() ? " active" : "")
            }
          >
            {item.label}
          </Link>
        ))}
      </div>

      <div className="navbarRight">
        <button className="desktopMenuBtn" onClick={handleLogout}>
          <LuLogOut className="desktopMenuIcon" />
          Log Out
        </button>
        <div className="userAvatar" title="Admin">
          AD
        </div>
      </div>

      <div className="navMenuMob">
        {showMenu ? (
          <IoClose className="mobMenu" onClick={() => setShowMenu(!showMenu)} />
        ) : (
          <IoMenu className="mobMenu" onClick={() => setShowMenu(!showMenu)} />
        )}

        <div className="navMenu" style={{ display: showMenu ? "flex" : "none" }}>
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="mobileMenuItem"
              onClick={handleMenuClick}
            >
              {item.label}
            </Link>
          ))}
          <div className="logoutBtn">
            <button className="desktopMenuBtn" onClick={handleLogout}>
              <LuLogOut className="logoutIcon" />
              <p className="logout">Log Out</p>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
